'use client';

import React from 'react';

const JsonLD: React.FC<{ value?: object | object[] }> & { TYPES: any } = ({ value }) => {
  if (!value) {
    return null;
  }
  const values = Array.isArray(value) ? value : [value];
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(
          values.map((val) => {
            return {
              '@context': 'https://schema.org',
              ...val,
            };
          }),
        ),
      }}
    />
  );
};

JsonLD.TYPES = {
  movies: 'Movie',
  series: 'TVSeries',
  music: 'MusicRecording',
  restaurants: 'Restaurant',
  videogames: 'VideoGame',
  apps: 'SoftwareApplication',
  books: 'book',
};

export default JsonLD;
